import { render, staticRenderFns } from "./egresos.vue?vue&type=template&id=4e2d2e5d&scoped=true&"
import script from "./egresos.vue?vue&type=script&lang=js&"
export * from "./egresos.vue?vue&type=script&lang=js&"
import style0 from "./egresos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./egresos.vue?vue&type=style&index=1&id=4e2d2e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d2e5d",
  null
  
)

export default component.exports